import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default function formatPhone(phone) {
  const parsed = parsePhoneNumberFromString(phone, 'US')
  return parsed.number
}
